import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../core';
import { ItemMarca } from '../../item-marca';

@Injectable({
    providedIn: 'root'
})
export class UsuarioMarcaHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/usuario`
    }

    /** Pesquisa as marcas cadastradas para o usuário informado */
    searchMarcas(idUsuario: number): Observable<ItemMarca[]> {
        return this.customHttp.get<ItemMarca[]>(`${this.pathApi}/${idUsuario}/marca`);
    }

    /** Pesquisa as marcas cadastradas para o usuário logado */
    searchMarcasUsuarioLogado(): Observable<ItemMarca[]> {
        return this.customHttp.get<ItemMarca[]>(`${this.pathApi}/0/marca`);
    }
}
